import React from 'react';
interface SelectableCardProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
}
export function SelectableCard({
  label,
  selected,
  onClick,
  className = ''
}: SelectableCardProps) {
  return <button type="button" onClick={onClick} className={`
        w-full text-left px-5 py-4 rounded-2xl font-bold transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2
        border-2
        ${selected ? 'bg-emerald-50/50 border-emerald-500 text-emerald-700 shadow-sm' : 'bg-white border-slate-100 text-slate-700 hover:border-slate-200 hover:bg-slate-50'}
        ${className}
      `} data-id="element-364">
      {label}
    </button>;
}